import { useState, useEffect, useCallback } from 'react';
import { leaderboardEvents, LeaderboardEvent } from '../api/leaderboard-events';
import { useLoader } from '../contexts/LoaderContext';
import { useAlert } from '../contexts/AlertContext';

export const useActiveLeaderboardEvent = () => {
  const [activeEvent, setActiveEvent] = useState<LeaderboardEvent | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const { showAlert } = useAlert();

  const fetchActiveEvent = useCallback(async () => {
    try {
      setIsLoading(true);
      showLoader();
      const response = await leaderboardEvents.getList();
      setActiveEvent(response.currentEvent);
    } catch (error) {
      console.error('Failed to fetch active leaderboard event:', error);
      showAlert('Failed to fetch active leaderboard event', 'error');
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  }, [showLoader, hideLoader, showAlert]);

  useEffect(() => {
    fetchActiveEvent();
  }, [fetchActiveEvent]);

  return {
    activeEvent,
    isLoading,
    refetch: fetchActiveEvent,
  };
};
